export default __webpack_public_path__ + "static/media/closeButton.377c4dcb.svg";